import { IDashDonorData } from '@nkr/models/index';
import { Utility } from '@nkr/services/utility';
import { OverlayTrigger, Popover, Table } from 'react-bootstrap';

interface IProps {
    data: IDashDonorData,
    formattedStartDate: string,
    formattedEndDate: string,
    isAdmin: boolean
}

const DonorProgress = (props: IProps) => {
    let { data: donorData, formattedStartDate, formattedEndDate } = props;

    return (
        <Table bordered striped>
            <thead>
                <tr>
                    <th colSpan={3} style={{ background: '#337ab7', color: 'white' }}><span style={{ float: 'left' }}>Donor Progress </span> <span style={{ float: 'right' }}>({formattedStartDate} - {formattedEndDate})</span></th>
                </tr>
                <tr>
                    <th style={{ backgroundColor: '#f0f0f0' }}>Stage</th>
                    <th style={{ textAlign: 'center', backgroundColor: '#f0f0f0' }}> Total </th>
                    <th style={{ textAlign: 'center', backgroundColor: '#f0f0f0' }}> Percent</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><strong>Registered:</strong></td>
                    <td style={{ textAlign: 'center' }}><strong>{donorData.startedCount}</strong></td>
                    <td style={{ textAlign: 'center' }}><strong>--</strong></td>
                </tr>
                <tr>
                    <td><strong>Ruled-Out:</strong></td>
                    <td style={{ textAlign: 'center' }}><strong>{donorData.ruledOutSum}</strong></td>
                    <td style={{ textAlign: 'center' }}><strong>{Utility.percent(donorData.ruledOutSum, donorData.startedCount)}</strong></td>
                </tr>
                <tr>
                    <td className='padding-left-10'> - Hard Rule-Outs:</td>
                    <td style={{ textAlign: 'center' }}>{donorData.hardRuleOutCount}</td>
                    <td style={{ textAlign: 'center' }}>{Utility.percent(donorData.hardRuleOutCount, donorData.startedCount)}</td>
                </tr>
                <tr>
                    <td className='padding-left-10'> - Soft Rule-Outs:</td>
                    <td style={{ textAlign: 'center' }}>{donorData.softRuleOutCount}</td>
                    <td style={{ textAlign: 'center' }}>{Utility.percent(donorData.softRuleOutCount, donorData.startedCount)}</td>
                </tr>
                <tr>
                    <td className='padding-left-10'> - Expired Rule-Outs{' '}<OverlayTrigger trigger={['hover', 'click']} placement='bottom' overlay={<Popover id='expired-rule-outs-info'>Expired registrations default to 90 days from registration date, but can be shorter per center selection.</Popover>}><span className='glyphicon glyphicon-info-sign'></span></OverlayTrigger>:</td>
                    <td style={{ textAlign: 'center' }}>{donorData.expiredRuleOutCount}</td>
                    <td style={{ textAlign: 'center' }}>{Utility.percent(donorData.expiredRuleOutCount, donorData.startedCount)}</td>
                </tr>
                <tr>
                    <td className='padding-left-10'> - Non-U.S. Rule-Outs:</td>
                    <td style={{ textAlign: 'center' }}>{donorData.nonUsRuleOutCount}</td>
                    <td style={{ textAlign: 'center' }}>{Utility.percent(donorData.nonUsRuleOutCount, donorData.startedCount)}</td>
                </tr>
                <tr>
                    <td><strong>In-Progress:</strong></td>
                    <td style={{ textAlign: 'center' }}><strong>{donorData.inProgressSum}</strong></td>
                    <td style={{ textAlign: 'center' }}><strong>{Utility.percent(donorData.inProgressSum, donorData.startedCount)}</strong></td>
                </tr>
                <tr>
                    <td className='padding-left-10'> - Incomplete Screening:</td>
                    <td style={{ textAlign: 'center' }}>{donorData.incompleteScreeningCount}</td>
                    <td style={{ textAlign: 'center' }}>{Utility.percent(donorData.incompleteScreeningCount, donorData.startedCount)}</td>
                </tr>
                <tr>
                    <td className='padding-left-10'> - Incomplete History:</td>
                    <td style={{ textAlign: 'center' }}>{donorData.incompleteHistoryCount}</td>
                    <td style={{ textAlign: 'center' }}>{Utility.percent(donorData.incompleteHistoryCount, donorData.startedCount)}</td>
                </tr>
                <tr>
                    <td className='padding-left-10'> - In Pre-Workup Labs Process:</td>
                    <td style={{ textAlign: 'center' }}>{donorData.preWorkupLabCount}</td>
                    <td style={{ textAlign: 'center' }}>{Utility.percent(donorData.preWorkupLabCount, donorData.startedCount)}</td>
                </tr>

                {props.isAdmin &&
                    <tr>
                        <td className='padding-left-10'> - At Center Select:</td>
                        <td style={{ textAlign: 'center' }}>{donorData.atCenterSelectCount}</td>
                        <td style={{ textAlign: 'center' }}>{Utility.percent(donorData.atCenterSelectCount, donorData.startedCount)}</td>
                    </tr>
                }

                <tr>
                    <td><strong>Completed:</strong></td>
                    <td style={{ textAlign: 'center' }}><strong>{donorData.completedAllCount}</strong></td>
                    <td style={{ textAlign: 'center' }}><strong>{Utility.percent(donorData.completedAllCount, donorData.startedCount)}</strong></td>
                </tr>
                <tr>
                    <td className='padding-left-10'> - Manual Rule-Outs:</td>
                    <td style={{ textAlign: 'center' }}>{donorData.manuallyRuledOutCount}</td>
                    <td style={{ textAlign: 'center' }}>{Utility.percent(donorData.manuallyRuledOutCount, donorData.startedCount)}</td>
                </tr>
                <tr>
                    <td style={{ paddingLeft: '5px' }}> - Not Ruled Out:</td>
                    <td style={{ textAlign: 'center' }}>{donorData.notManuallyRuledOut}</td>
                    <td style={{ textAlign: 'center' }}>{Utility.percent(donorData.notManuallyRuledOut, donorData.startedCount)}</td>
                </tr>
                <tr>
                    <td><strong>Confirm Donated:</strong></td>
                    <td style={{ textAlign: 'center' }}><strong>{donorData.confirmedDonated}</strong></td>
                    <td style={{ textAlign: 'center' }}><strong>{Utility.percent(donorData.confirmedDonated, donorData.startedCount)}</strong></td>
                </tr>
            </tbody>
        </Table>
    );
}

export default DonorProgress;